<template>
  <div>
    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="85px"
        size="mini"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio :label="1">玩家昵称</el-radio>
            <el-radio :label="2">uid</el-radio>
            <el-radio :label="3">aid</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          :label="
            form.queryType == 1
              ? '玩家昵称：'
              : form.queryType == 2
              ? 'uid：'
              : 'aid：'
          "
        >
          <el-input
            v-if="form.queryType == 1"
            v-model="form.name"
            clearable
            style="width: 170px"
          ></el-input>
          <el-input
            v-if="form.queryType == 2"
            v-model="form.uid"
            clearable
            style="width: 170px"
          ></el-input>
          <el-input
            v-if="form.queryType == 3"
            v-model="form.aid"
            clearable
            style="width: 170px"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="playerList"
      border
      size="small"
      style="width: 1146px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="playerList.length == 0"
    >
      <el-table-column prop="uid" label="uid" align="center" width="80">
      </el-table-column>

      <el-table-column prop="zoneId" label="区服" align="center" width="80">
      </el-table-column>

      <el-table-column prop="name" label="昵称" align="center" width="120">
      </el-table-column>

      <el-table-column prop="lv" label="等级" align="center" width="80">
      </el-table-column>

      <el-table-column prop="aid" label="aid" align="center" width="80">
      </el-table-column>
      <el-table-column
        prop="channelName"
        label="渠道"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.channelName }}
        </template>
      </el-table-column>
      <el-table-column label="账号被冻结" align="center" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.thirdPartyId.search('DISCARDED_') == -1"
            >否</span
          >
          <span v-else style="color: red">是</span>
        </template>
      </el-table-column>
      <el-table-column label="在灰名单" align="center" width="75">
        <template slot-scope="scope">
          <span v-if="!scope.row.isInteractiveForbidden" style="">否</span>
          <span v-if="scope.row.isInteractiveForbidden" style="color: red"
            >是</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="payHistory.totalPaidCents"
        label="付费总额(元)"
        align="center"
        width="90"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.payHistory.totalPaidPriceCents / 100).toFixed(2) }}</span>
        </template>      
      </el-table-column>

      <el-table-column label="最近活跃" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.latestActiveAt)) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.createdAt)) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            round
            size="mini"
            @click="openPlayerInfoDialog(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 玩家详情框 -->
    <PlayerInfoDialog
      v-if="shouldPlayerInfoDialogVisible"
      @close="onPlayerInfoDialogClosed()"
      :value="valueForPlayerInfoDialog"
    ></PlayerInfoDialog>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import PlayerInfoDialog from "./dialog/PlayerInfoDialog";

export default {
  data() {
    return {
      shouldPlayerInfoDialogVisible: false, // 编辑成员列表框是否应该显示出来
      valueForPlayerInfoDialog: null, // 要传递给成员列表框的数据
      playerList: [], // 列表里展示的数据
      form: {
        queryType: 1, // 查询方式（1-玩家昵称 2-uid 3-aid)
        uid: "",
        aid: "",
        name: "", //
      },
    };
  },

  created() {
    // 传入uid 进行查询
    let uid = this.$route.query.uid;
    if (uid != null) {
      this.form.queryType = 2;
      this.form.uid = uid;
      this.loadplayerList(0, 10);
      return;
    }

    // 传入aid 进行查询
    let aid = this.$route.query.aid;
    if (aid != null) {
      this.form.queryType = 3;
      this.form.aid = aid;
      this.loadplayerList(0, 10);
      return;
    }
  },

  components: {
    PlayerInfoDialog,
  },

  methods: {
    loadMore() {
      // 只有使用昵称查询的时候才需要考虑使用
      if (this.form.queryType == 1) {
        this.loadplayerList(this.playerList.length, 10);
      }
    },
    /**
     * 点击查询按钮
     */
    async onClickQueryBtn(skip, limit) {
      await this.loadplayerList(0, 10);
    },

    /**
     * 拉取集合
     */
    async loadplayerList(skip, limit) {
      let condition = "";
      let value = "";
      switch (this.form.queryType) {
        case 1: {
          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.playerList = [];
          }
          condition = "name";
          value = this.form.name;

          break;
        }
        case 2: {
          this.playerList = [];
          condition = "uid";
          value = "" + this.form.uid;
          break;
        }
        case 3: {
          this.playerList = [];
          condition = "aid";
          value = "" + this.form.aid;
          break;
        }
      }
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/player/getPlayerList`,
          {
            skip: skip,
            limit: limit,
            condition: condition,
            value: value,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.playerList = this.playerList.concat(listInResponse);
    },

    /**
     * 打开编辑对话框
     */
    async openPlayerInfoDialog(entry) {
      this.shouldPlayerInfoDialogVisible = true;
      this.valueForPlayerInfoDialog = {
        info: entry,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onPlayerInfoDialogClosed() {
      this.shouldPlayerInfoDialogVisible = false;
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

  